import styled from 'styled-components';

import { BaseStyle, ReactTableStyles } from '@nhl/nhl-breakaway-ui';

import { StyledSelect } from '../../styles';

export const HideTextOverflowColumnStyle = {
    textOverflow: 'ellipsis',
    whiteSpace: 'wrap',
    overflow: 'hidden',
};

export const TeamNameColumnStyle = {
    ...HideTextOverflowColumnStyle,
    display: 'flex',
    fontWeight: 'initial',
    padding: '0',
    whiteSpace: 'normal',
};

export const FiveGamesRow = styled.div`
    display: flex;

    ${BaseStyle.Mixins.screenSizes.large} {
        flex-direction: row;
    }
    flex-direction: column;
`;

export const PlayerTableContainer = styled.div`
    flex: 3;

    ${ReactTableStyles.CommonTableStyling};

    .rt-table-container {
        ${ReactTableStyles.TableScrollShadows}
    }

    .career-totals {
        background: ${({ theme }) => theme.Surface.disabled};

        .rt-td {
            ${BaseStyle.Mixins.fontStyles.table.bold}
        }
    }
`;

export const LabelContainer = styled.div`
    display: flex;
    flex-direction: column-reverse;
    justify-content: left;
    padding: 20px 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
        justify-content: space-between;

        h4 {
            align-self: center;
        }
    }
`;

export const SelectContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    align-self: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-bottom: 0;
        align-self: auto;
    }

    ${StyledSelect}:first-child {
        margin-left: 0;
    }
`;

export const EliteProspectsLink = styled.div`
    margin-top: 18px;
    height: 76px;

    a {
        color: ${({ theme }) => theme.Utility.cta};
    }
`;

export const GamecenterLink = styled.a`
    &&& {
        color: ${({ theme }) => theme.Utility.cta};
        text-decoration: underline;
    }
`;

// standard container in which to display a message if a table has no data
export const EmptyTableMessage = styled.div`
    ${BaseStyle.Mixins.fontStyles.table.bold}
    align-items: center;
    background-color: ${({ theme }) => theme.Table.zebraStripe};
    display: flex;
    height: 100px;
    justify-content: center;
    padding-bottom: 20px;
`;
